import { Link } from 'react-router-dom';
import './KitchenFittersPage.css';

const COLLECT = [
  {
    title: 'Steel Beams & Sections',
    image: '/images/construction-building/construction-steel-beams.png',
  },
  {
    title: 'Metal Studs & Channels',
    image: '/images/construction-building/construction-metal-studs.png',
  },
  {
    title: 'Pipes & Conduit',
    image: '/images/construction-building/construction-pipes-conduit.png',
  },
  {
    title: 'Wire Mesh & Rebar',
    image: '/images/construction-building/construction-rebar-mesh.png',
  },
  {
    title: 'Metal Offcuts',
    image: '/images/construction-building/construction-metal-offcuts.png',
  },
  {
    title: 'Site Hardware & Fittings',
    image: '/images/construction-building/construction-site-hardware.png',
  },
];

const STEPS = [
  {
    n: '1',
    title: 'Post your scrap',
    body: 'Add photos, your site postcode and what metal needs clearing from the build.',
  },
  {
    n: '2',
    title: 'We find collectors',
    body: 'Nearby licensed collectors review your listing and offer a collection window.',
  },
  {
    n: '3',
    title: 'Collector confirms',
    body: 'Agree access, parking and timing around site hours and loading points.',
  },
  {
    n: '4',
    title: 'Scrap is collected',
    body: 'Steel, rebar and site metal leave through licensed handling routes.',
  },
  {
    n: '5',
    title: 'You get more done',
    body: 'Your crew stays on the programme while leftovers are cleared from site.',
  },
];

const REASONS = [
  {
    title: 'Licensed & verified collectors',
    body: 'Matched collectors are verified scrap carriers — not unlicensed tip runs.',
  },
  {
    title: 'Compliant & safe',
    body: 'Keep strip-outs and fit-outs tidy with accountable metal clearances.',
  },
  {
    title: 'Cost effective',
    body: 'Post for free and avoid losing a crew day hauling steel yourself.',
  },
  {
    title: 'Better for the environment',
    body: 'Construction metals are recovered for reuse instead of mixed waste.',
  },
  {
    title: 'Built for busy sites',
    body: 'Share access notes and photos so collectors arrive ready for site scrap.',
  },
];

const TRUST = [
  { label: 'Save time', detail: 'Clear site leftovers fast' },
  { label: 'Save money', detail: 'Free to post online' },
  { label: 'Recycle more', detail: 'Steel recovered properly' },
  { label: 'Stay compliant', detail: 'Licensed collectors only' },
];

export default function ConstructionBuildingPage() {
  return (
    <div className="kf-page">
      <section className="kf-hero" aria-labelledby="cb-hero-heading">
        <div className="kf-hero-inner">
          <div className="kf-hero-copy">
            <p className="kf-kicker">SnapScrap for trade</p>
            <h1 id="cb-hero-heading">
              Scrap collection for <span>construction & building companies</span>
            </h1>
            <p className="kf-lead">
              Clear steel, rebar, conduit and site metal leftovers quickly and responsibly — so your
              next phase stays tidy, safe and on programme.
            </p>

            <div className="kf-hero-actions">
              <Link className="kf-btn" to="/post-scrap">
                Post scrap free →
              </Link>
              <Link className="kf-btn kf-btn-ghost" to="/how-it-works">
                See how it works
              </Link>
            </div>

            <ul className="kf-trust">
              {TRUST.map((item) => (
                <li key={item.label}>
                  <strong>{item.label}</strong>
                  <span>{item.detail}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="kf-hero-media">
            <img
              src="/images/businesses/biz-construction.png"
              alt="Construction and building scrap ready for collection"
            />
            <p className="kf-hero-note">
              Built for site teams — steel, studs, conduit, rebar and offcuts
            </p>
          </div>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="cb-collect-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="cb-collect-heading">What scrap we collect</h2>
            <p>Typical metal leftovers from builds, strip-outs and site clearances</p>
          </header>

          <ul className="kf-collect-grid">
            {COLLECT.map((item) => (
              <li key={item.title}>
                <div className="kf-collect-image">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
                <h3>{item.title}</h3>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-section kf-section-tint" aria-labelledby="cb-steps-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="cb-steps-heading">How SnapScrap works</h2>
            <p>Five simple steps from posting leftovers to a clearer site</p>
          </header>

          <ol className="kf-steps">
            {STEPS.map((step) => (
              <li key={step.n}>
                <span className="kf-step-n" aria-hidden="true">
                  {step.n}
                </span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="cb-why-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="cb-why-heading">Why construction companies choose SnapScrap</h2>
            <p>Clear space, keep programmes moving, and handle metal the responsible way</p>
          </header>

          <ul className="kf-why-grid">
            {REASONS.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-cta" aria-label="Post scrap call to action">
        <div className="kf-cta-inner">
          <div className="kf-cta-copy">
            <h2>Post your construction scrap for free today</h2>
            <p>
              List leftovers from your next build or strip-out and get matched with a licensed
              collector.
            </p>
          </div>
          <Link className="kf-btn kf-btn-light" to="/post-scrap">
            Post scrap free →
          </Link>
        </div>
      </section>
    </div>
  );
}
